import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../services/seo.service';
import { ImageService } from '../../services/image.service';
import { NgOptimizedImage } from '@angular/common';
import { buildSiteUrl, siteConfig } from '../../config/site-config';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {
  readonly brandName = siteConfig.brand.displayName;
  readonly contactEmail = siteConfig.contact.email;

  constructor(
    private seoService: SeoService,
    public imageService: ImageService
  ) { }

  ngOnInit(): void {
    this.seoService.setTitle('Über uns');
    this.seoService.setDescription('Lerne uns kennen – wer wir sind, was uns antreibt und warum wir unsere Leidenschaft für Kräuter und Natur mit dir teilen möchten.');
    this.seoService.setCanonicalUrl();
    this.seoService.setOpenGraphTags({
      title: 'Über uns',
      description: 'Lerne uns kennen – wer wir sind, was uns antreibt und warum wir unsere Leidenschaft für Kräuter und Natur mit dir teilen möchten.',
      image: siteConfig.seo.defaultImageUrl
    });
    this.seoService.setBreadcrumbSchema([
      {name: 'Startseite', url: buildSiteUrl('/')},
      {name: 'Über uns', url: buildSiteUrl(siteConfig.routes.aboutPath)}
    ]);
    this.seoService.setNoIndex(false);
  }

}


